import { useDispatch, useSelector } from "react-redux";
import { Config } from "../../config/Config";
import { useEffect } from "react";
import { CmsPageAction } from "../../redux/Action/CmsPageAction";
import { StorageConstants } from "../../constants/Constants";
import Spinner from "../../components/Spinner";
import CommanHeader from "../../components/Layout/CommanHeader";
import { useLocation } from "react-router-dom";
import Header from "../../components/Layout/Header";
import UserBar from "../../components/Userbar/UserBar";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Footer from "../../components/Layout/Footer";
import { FormattedMessage } from "react-intl";

const CmsPage = () => {
    const dispatch = useDispatch<any>()
    const { pathname } = useLocation()
    const cmsPageData = useSelector((state: any) => state.CmsPageState)

    const token = Config.IS_USER_LOGIN_TOKEN;
    const { email, salon_name, buisness_images } = Config?.USER_DETAILS ? Config?.USER_DETAILS : "";
    const payload = { name: salon_name, email: email, image: buisness_images?.[0]?.file_path }

    const slug = pathname.split('/').pop();

    useEffect(() => {
        if (slug) {
            dispatch(CmsPageAction({ slug, user_type: StorageConstants?.USERTYPE }));
        }
    }, [slug, dispatch]);

    return (
        <>
            {cmsPageData?.loading ? <Spinner /> : ""}

            {
                !token && <CommanHeader />
            }

            <main>
                {token && <Header payload={payload} />}
                {/* {token && <UserBar payload={payload} />} */}
                <div className='container py-5'>
                    {/* {token && <Breadcrumb />} */}
                    <h1 className='title mb-4'>{cmsPageData?.data?.data?.title ? cmsPageData?.data?.data?.title : ''}</h1>
                    <div dangerouslySetInnerHTML={{ __html: cmsPageData?.data?.data?.content }}>
                    </div>
                </div>
            </main>
            <Footer />

        </>
    )
}

export default CmsPage;